import React, { useEffect, useRef, useState } from "react";

export default function StatCounter({ value, prefix = "", suffix = "", label, decimals = 0, inline = false }) {
  const [display, setDisplay] = useState(0);
  const ref = useRef(null);
  const startedRef = useRef(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !startedRef.current) {
          startedRef.current = true;
          const duration = 1600;
          const start = performance.now();
          const step = (now) => {
            const p = Math.min(1, (now - start) / duration);
            const eased = 1 - Math.pow(1 - p, 3);
            setDisplay(value * eased);
            if (p < 1) requestAnimationFrame(step);
          };
          requestAnimationFrame(step);
        }
      },
      { threshold: 0.4 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [value]);

  const formatted =
    decimals > 0 || value % 1 !== 0
      ? display.toFixed(1)
      : Math.floor(display).toLocaleString();

  if (inline) {
    return (
      <span ref={ref} className="font-display text-4xl md:text-5xl font-bold tracking-tight tabular-nums" style={{ color: "var(--brand-700)" }}>
        {prefix}{formatted}{suffix}
      </span>
    );
  }

  return (
    <div ref={ref} className="text-center px-4 py-6">
      <div className="stat-line" />
      <div className="font-display text-3xl md:text-4xl font-bold text-brand tracking-tight">
        {prefix}
        {formatted}
        {suffix}
      </div>
      <div className="mt-2 text-xs md:text-sm uppercase tracking-[0.15em] text-muted-foreground font-medium">
        {label}
      </div>
    </div>
  );
}
